import React from "react";
import PropTypes from "prop-types";
import {
  CardWrapper,
  Row,
  Column,
  Title,
  Text,
  CollapsibleLink,
} from "./styles/job-description-styles";

class JobDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }

  onCollapseClick = () => {
    this.setState(({ isExpanded }) => ({
      isExpanded: !isExpanded,
    }));
  };

  render() {
    const { description } = this.props;
    const { isExpanded } = this.state;

    return (
      <CardWrapper>
        <Row>
          <Column className={isExpanded ? "expanded" : ""} collapsibleType isExpanded={isExpanded}>
            <Title>Description</Title>
            <Text dangerouslySetInnerHTML={{ __html: description }} />
             {description.length > 150 && (
            <CollapsibleLink onClick={this.onCollapseClick}>
              {isExpanded ? "show less" : "read more"}
            </CollapsibleLink>
          )}
          </Column>
        </Row>
      </CardWrapper>
    );
  }
}

JobDescription.propTypes = {
  description: PropTypes.string.isRequired,
};

export default JobDescription;
